import { unpurry } from "@suse-o11y/unpurry";
import { times as times_ } from "remeda";

type UncountedTimes = <T>(count: number, fn: (index: number) => T) => Array<T>;

export const times: typeof times_ & UncountedTimes = unpurry(times_, 2);
